import { SxProps, Theme } from "@mui/material";
import colors from "../../../common/styles/colors";

export const useFreyaPrintSettingsScannerSelectorStyles = () => ({
  formLabel: {
    color: colors.greenColor1,
    fontSize: 12,
    fontWeight: 600,
    textTransform: "uppercase" as const
  } as SxProps<Theme>,

  descriptionText: {
    my: 1
  } as SxProps<Theme>,

  gridContainer: {
    width: "100%",
    overflowX: "hidden",
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "row",
    justifyContent: "flex-start",
    flexWrap: "wrap",
    m: 0,
    boxSizing: "border-box",
    gap: "10px"
  } as SxProps<Theme>,

  scannerItemContainer: {
    flex: "0 0 calc(20% - 8px)",
    maxWidth: "calc(20% - 8px)",
    textAlign: "center",
    "@media (max-width: 600px)": {
      flex: "0 0 calc(32% - 6.66px)",
      maxWidth: "calc(32% - 6.66px)"
    },
    "@media (max-width: 400px)": {
      flex: "0 0 calc(50% - 5px)",
      maxWidth: "calc(50% - 5px)"
    }
  } as SxProps<Theme>,

  scannerBox: (isSelected: boolean): SxProps<Theme> => ({
    width: "100%",
    padding: 2,
    cursor: "pointer",
    borderRadius: "6px",
    border: isSelected ? `1px solid ${colors.primary}` : `1px solid ${colors.lightGrey4}`,
    backgroundColor: isSelected ? colors.blue[100] : "transparent",
    "&:hover, &:focus": {
      backgroundColor: colors.blue[100],
      color: colors.white
    },
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxSizing: "border-box"
  }),

  scannerImage: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
    aspectRatio: "1 / 1",
    "@media (max-width: 1200px)": {
      width: "90%",
      height: "90%"
    },
    "@media (max-width: 800px)": {
      width: "85%",
      height: "85%"
    },
    "@media (max-width: 600px)": {
      width: "80%",
      height: "80%"
    },
    "@media (max-width: 400px)": {
      width: "75%",
      height: "75%"
    }
  } as SxProps<Theme>,
  scannerLabel: (isActive: boolean) =>
    ({
      textAlign: "center",
      fontSize: 14,
      marginTop: "8px",
      color: isActive ? colors.primary : colors.darkGrey1
    } as SxProps<Theme>)
});
